import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: '"Outfit", "Helvetica", "Arial", sans-serif', // [cite: 324]
    h1: {
      fontSize: '26px', // [cite: 327]
      fontWeight: 600, // [cite: 325]
      color: '#000000', // [cite: 313]
    },
    h2: {
      fontSize: '18px', 
      fontWeight: 600, // [cite: 325]
      color: '#000000', // [cite: 313]
      marginTop: '24px', 
      marginBottom: '8px', 
    },
    body1: {
      fontSize: '14px', // [cite: 328]
      fontWeight: 400, // [cite: 325]
      color: '#000000', // [cite: 313]
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '14px', // [cite: 328]
      fontWeight: 400, // [cite: 325]
      color: '#828282', // [cite: 314]
    },
    button: {
      fontWeight: 500, // [cite: 325]
      textTransform: 'none', 
      fontSize: '16px',
    }
  },
  palette: {
    primary: {
      main: '#008081', // [cite: 308]
      contrastText: '#FFFFFF', 
    },
    background: {
      default: '#FFFFFF', // [cite: 311]
    },
    text: {
      primary: '#000000', // [cite: 313]
      secondary: '#828282', // [cite: 314]
    },
    error: {
      main: '#FF3B30', // [cite: 319]
    }
  },
  shape: {
    borderRadius: 8, // [cite: 331]
  },
  spacing: 8, // [cite: 335]
});